import { render } from "./textarea.vue?vue&type=template&id=958d6c76&scoped=true"
import script from "./textarea.vue?vue&type=script&lang=js"
export * from "./textarea.vue?vue&type=script&lang=js"

import "./textarea.vue?vue&type=style&index=0&id=958d6c76&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-958d6c76"

export default script